import { render } from "./ContractAdmin.vue?vue&type=template&id=3c0c67ac"
import script from "./ContractAdmin.vue?vue&type=script&lang=js"
export * from "./ContractAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__